import { render } from "./FormList.vue?vue&type=template&id=447abef0&scoped=true"
import script from "./FormList.vue?vue&type=script&lang=js"
export * from "./FormList.vue?vue&type=script&lang=js"

import "./FormList.vue?vue&type=style&index=0&id=447abef0&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-447abef0"

export default script